import {
  rdbV1FiltersTeamsList,
  rdbV1FiltersYearsList,
  v2OrganizationsScheduleDetail,
} from '@on3/api';
import withAuthentication from '@on3/ui-lib/hocs/withAuthentication';
import withValidUrl from '@on3/ui-lib/hocs/withValidUrl';
import { proxyApi } from '@on3/ui-lib/index';
import { getFulfilledValue } from '@on3/ui-lib/utils/api';
import { slugify } from '@on3/ui-lib/utils/slugify';
import { type AxiosError } from 'axios';
import { SchedulePage } from 'components/Schedules/College/SchedulePage';
import { type GetServerSideProps } from 'next';
import { createKey } from 'utils/meta';

import { type ISchedulePageProps } from './[year]/schedule';

const CollegeSchedulePage = (props: ISchedulePageProps) => {
  const { orgKey, year, sportKey } = props?.schedule?.relatedModel || {};

  return <SchedulePage {...props} key={createKey(orgKey, year, sportKey)} />;
};

export const getServerSideProps: GetServerSideProps = async (ctx) => {
  const siteData = await withValidUrl.isValid(ctx);
  const userData = await withAuthentication.isAuth(ctx);
  const { sport, year } = ctx.query;
  const { currentSite, scheduleSports } = siteData || {};
  const orgKey = currentSite?.organizationKey;

  const sportKey = scheduleSports?.find(
    (sp) => sp?.name && slugify(sp?.name) === sport,
  )?.key;

  if (!siteData || !orgKey) {
    return {
      notFound: true,
    };
  }

  const defaultYear =
    sportKey === 1
      ? siteData.defaultYears.footballSeasonYear
      : siteData.defaultYears.nonFootballSeasonYear;
  const paramYear = year ? +year : defaultYear;

  try {
    const scheduleParams = { year: paramYear, sportKey, orgKey };
    const teamsParams = { year: paramYear, sportKey, groupBy: true };
    const [schedule, teams, years] = await Promise.allSettled([
      v2OrganizationsScheduleDetail(proxyApi, scheduleParams),
      rdbV1FiltersTeamsList(proxyApi, teamsParams),
      rdbV1FiltersYearsList(proxyApi),
    ]);
    const data = {
      pageType: 'database',
      siteData,
      userData,
      schedule: getFulfilledValue(schedule),
      filters: {
        teams: getFulfilledValue(teams),
        years: getFulfilledValue(years),
        sports: scheduleSports,
      },
    };

    return { props: { ...data } };
  } catch (error) {
    const err: AxiosError<unknown> = error as AxiosError<unknown>;

    console.error(err);

    return { props: {} };
  }
};

export default withValidUrl(CollegeSchedulePage);
